import { Text } from '@avanta/shared/components/Text';
import { cn } from '@avanta/shared/utils/cn';

export interface InfoItemProps {
  icon: React.ElementType;
  label: string;
  description?: string;
  labelClassName?: string;
  alignStart?: boolean;
}

export const InfoItem = ({
  icon: Icon,
  label,
  description,
  labelClassName,
  alignStart = false,
}: InfoItemProps): React.ReactElement => (
  <div className={cn('flex gap-2', alignStart ? 'items-start' : 'items-center')}>
    <Icon className="size-4 shrink-0 text-teal-600" />
    <div className="flex min-w-0 flex-col">
      <Text variant="text-sm-regular" className={labelClassName}>
        {label}
      </Text>
      {description ? (
        <Text variant="text-xs-regular" className="text-gray-500">
          {description}
        </Text>
      ) : null}
    </div>
  </div>
);
